import endpoints from '../endpoints';
import fetchReq from '../fetch';

type EnrollSsiOptions = {
  accessToken: string;
  apikey: string;
};

export function fetchEnrollSsi({ accessToken, apikey }: EnrollSsiOptions) {
  return fetchReq({
    headers: {
      access_token: accessToken
    },
    mark: 'enroll_ssi',
    method: 'POST',
    url: `${endpoints.enrollSsi}?apikey=${apikey}`
  });
}

export function fetchOrchEnrollSsi({ accessToken, apikey }: EnrollSsiOptions) {
  return fetchReq({
    headers: {
      access_token: accessToken
    },
    mark: 'enroll_ssi',
    method: 'POST',
    url: `${endpoints.orchestrator.enrollSsi}?apikey=${apikey}`
  });
}
